import script from "./TheHeaderProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHeaderProfile.vue?vue&type=script&setup=true&lang=js"

import "./TheHeaderProfile.vue?vue&type=style&index=0&id=015ce035&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-015ce035"]])

export default __exports__